import {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {voiceFlowFunction} from './utils';

const VoiceFlow = ({
  projectID,
  userName,
  GUID,
  locale,
  onOpen,
  onClose,
  logger,
  loadAutomatically = true,
  showBubble: propShowBubble = true,
}) => {
  const [showBubble, setShowBubble] = useState(propShowBubble);
  const loadScript = useCallback(
    (showBubble = true) => {
      if (typeof window !== 'undefined') {
        setShowBubble(showBubble);
        voiceFlowFunction({projectID, userName, GUID, locale, showBubble, onOpen, onClose, logger});
      }
    },
    [GUID, locale, logger, onClose, onOpen, projectID, userName]
  );

  useEffect(() => {
    if (__CLIENT__) {
      window.chat = window.chat || {};
      window.chat.load = loadScript;
    }
    loadAutomatically && loadScript(showBubble);
  }, [loadScript, loadAutomatically, onOpen, onClose, showBubble]);

  return null;
};

VoiceFlow.propTypes = {
  projectID: PropTypes.string.isRequired,
  userName: PropTypes.string,
  GUID: PropTypes.string,
  locale: PropTypes.string.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  loadAutomatically: PropTypes.bool,
  logger: PropTypes.object,
  showBubble: PropTypes.bool,
};

export default VoiceFlow;
